import React, { type PropsWithChildren } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { useIsClientReady } from './hooks/use-is-client-ready.tsx';

export type RenderOnClientProps = PropsWithChildren<{ fg?: string }>;

const RenderOnClientOld = ({ children, fg: featureGateName }: RenderOnClientProps) => {
	const isClientReady = useIsClientReady();

	// eslint-disable-next-line jira/ff/static-feature-flags
	if (featureGateName && !fg(featureGateName)) {
		return children;
	}

	if (isClientReady) {
		return children;
	}

	return null;
};

const RenderWhenReady = ({ children }: PropsWithChildren) => {
	const isClientReady = useIsClientReady();
	if (isClientReady) {
		return children;
	}

	return null;
};
const RenderOnClientNew = ({ children, fg: featureGateName }: RenderOnClientProps) => {
	// eslint-disable-next-line jira/ff/static-feature-flags
	if (featureGateName && !fg(featureGateName)) {
		return children;
	}

	return <RenderWhenReady>{children}</RenderWhenReady>;
};

/**
 * Renders children only on the client side.
 *
 * @param children - The children to render.
 * @param fg - The feature gate name.
 */
export const RenderOnClient = componentWithCondition(
	() => fg('fix-render-on-client-remount'),
	RenderOnClientNew,
	RenderOnClientOld,
);
